var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 3.33337C10.4606 3.33337 10.8337 3.70647 10.8337 4.16671V15.8334C10.8337 16.2936 10.4606 16.6667 10.0003 16.6667C9.54009 16.6667 9.16699 16.2936 9.16699 15.8334V4.16671C9.16699 3.70647 9.54009 3.33337 10.0003 3.33337Z",
    fill: "#3CAE8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41107 10.2441C4.73651 9.91868 5.26414 9.91868 5.58958 10.2441L10.0003 14.6549L14.4111 10.2441C14.7365 9.91868 15.2641 9.91868 15.5896 10.2441C15.915 10.5696 15.915 11.0972 15.5896 11.4226L10.5896 16.4226C10.2641 16.7481 9.73651 16.7481 9.41107 16.4226L4.41107 11.4226C4.08563 11.0972 4.08563 10.5696 4.41107 10.2441Z",
    fill: "#3CAE8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredit);
export default __webpack_public_path__ + "static/media/credit.1c246fc7d041ac18d2af308e5f2a388c.svg";
export { ForwardRef as ReactComponent };